import * as React from 'react';

import { Dropdown, IDropdownOption } from '@fluentui/react';

const options: IDropdownOption[] = [
  { key: 'America/Los_Angeles', text: 'America/Los_Angeles' },
  { key: 'America/New_York', text: 'America/New_York' },
  { key: 'America/Chicago', text: 'America/Chicago' },
  { key: 'America/Phoenix', text: 'America/Phoenix' },
];

interface Props {
  value: string;
  label?: string;
  required?: boolean;
  onChange: (timezone: string) => void;
}

export const TimezoneSelector = ({ value, label, required, onChange }: Props) => {
  const onDropDownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if (option) {
      onChange(option.key as string);
    }
  };

  return <Dropdown label={label} required={required} selectedKey={value} options={options} onChange={onDropDownChange} />;
};
